/**
 * 题目工具：分页与页码计算。
 * - pagebreak 题目按"分割符"语义把 questions 列表切成多页
 * - pageNumberMap 给每个题号计算所在页（1 开始；pagebreak 自身也会带一个页号，
 *   即"它前面的内容所在的页"——与编辑端的视觉一致）
 */
import type { QuestionType } from './types';

export function paginateQuestions<T extends { id: string; type: QuestionType }>(questions: T[]): T[][] {
  const pages: T[][] = [];
  let current: T[] = [];
  for (const q of questions) {
    if (q.type === 'pagebreak') {
      pages.push(current);
      current = [];
    } else {
      current.push(q);
    }
  }
  pages.push(current);
  // 去掉末尾空页（最后一个 pagebreak 后没题的情况）
  return pages.filter((p, i) => i < pages.length - 1 || p.length > 0);
}

export function pageNumberMap<T extends { id: string; type: QuestionType }>(questions: T[]): Map<string, number> {
  const pages = paginateQuestions(questions);
  const map = new Map<string, number>();
  let cursor = 1;
  for (const page of pages) {
    cursor += 1; // 下一组题所在的页号
    for (const q of page) map.set(q.id, cursor);
  }
  return map;
}